import { Grid, LinearProgress } from '@material-ui/core'
import moment from 'moment'
import PropTypes from 'prop-types'
import React, { useContext, useEffect, useState } from 'react'
import changeLogo from '../../assets/images/altera-logo.png'
import ButtonGZ from '../../components/Button'
import FormNavigation from '../../components/FormNavigation'
import ImageUpload from '../../components/LogoUpload'
import MomentData from '../../components/MomentData'
import SelectUnityToScriptsAndMoments from '../../components/SelectUnityToScriptsAndMoments'
import ToastMessages from '../../components/ToastMessages'
import Context from '../../context'
import { FORM_OBJECT, OBLIGATED_FIELDS } from '../../helpers/Variables'
import { createMoment, getThemesList, getUnitiesList } from '../../services/ClubeApi'
import ImageUploadToS3ge from '../../services/ImageUpload'
import { getLoggedUser, isAuthenticated } from '../../services/auth'
import history from '../../services/history'

const { REACT_APP_IMAGES_URL } = process.env

function MomentForm({ location }) {
  const { state } = location
  const { user, setUser, setOpenToast, setAboutCurrentPage, setShowLoadingModal } =
    useContext(Context)
  const obligatedList = OBLIGATED_FIELDS
  const [formObject, setFormObject] = useState(FORM_OBJECT)
  const [steps, setSteps] = useState({
    step: 1,
    maxStep: 3
  })

  const [newLogo, setNewLogo] = useState(changeLogo)
  const [iconLogo, setIconLogo] = useState(changeLogo)
  const [crop, setCrop] = useState({
    aspect: 3 / 2,
    unit: '%',
    width: 50,
    height: 50,
    x: 25,
    y: 10
  })
  const [logoToUpload, setLogoToUpload] = useState(null)

  const [fullPartnerList, setFullPartnerList] = useState([])
  const [selectedPartnerList, setSelectedPartnerList] = useState([])
  const [isLoading, setIsLoading] = useState(true)
  const [missInputs, setMissInputs] = useState(false)

  const [whiteLabels, setWhiteLabels] = useState([])

  useEffect(() => {
    if (isAuthenticated) {
      setUser(getLoggedUser())
    } else {
      history.replace('/')
    }
    setAboutCurrentPage({
      title: 'Adicionar Momento',
      buttons: [{ title: 'Voltar', pathname: '/moments' }]
    })

    let unitPromise = getUnitiesList().then(r => {
      setFullPartnerList([...r])
    })
    let whitelabelPromise = getThemesList().then(r => {
      setWhiteLabels([...r])
    })
    Promise.all([unitPromise, whitelabelPromise]).then(() => setIsLoading(false))

    if (state && state.momentToEdit) {
      const { momentToEdit } = state
      const { MomentsPartnerLists } = momentToEdit

      setSelectedPartnerList(
        MomentsPartnerLists.map(item => {
          return {
            ...item,
            id: item.partnerUnitId,
            logo: item.PartnerUnit.logo || '',
            fantasyName: item.PartnerUnit.fantasyName || ''
          }
        })
      )

      setNewLogo(`${REACT_APP_IMAGES_URL}${momentToEdit.image}`)
      setIconLogo(`${REACT_APP_IMAGES_URL}${momentToEdit.image}`)

      setFormObject({
        ...momentToEdit,
        momentsWhiteLabels: momentToEdit.MomentsWhiteLabels || momentToEdit.momentsWhiteLabels || []
      })
    }
  }, [])

  const handleContinue = async () => {
    if (steps.step < steps.maxStep) {
      setSteps({ ...steps, step: steps.step + 1 })
    }

    if (steps.step === steps.maxStep && !missInputs) {
      setIsLoading(true)
      setShowLoadingModal(true)

      let image = formObject.image || ''

      console.log(typeof image)
      if (typeof logoToUpload !== 'string' || logoToUpload !== null) {
        try {
          image = await ImageUploadToS3ge(logoToUpload)
        } catch (e) {
          console.log('Não conseguiu enviar a logo', e)
        }
      } else {
        image = logoToUpload || formObject.cover
      }

      const momentsPartnerList = selectedPartnerList.map(item => {
        return { partnerUnitId: item.id, description: item.description }
      })

      const startDate = moment(formObject.startDate).format('YYYY-MM-DD').toString()
      const endDate = moment(formObject.endDate).format('YYYY-MM-DD').toString()

      const momentToSave = {
        ...formObject,
        image,
        momentsPartnerList,
        startDate,
        endDate,
        momentsWhiteLabels: !formObject.momentsWhiteLabels?.length
          ? user?.WhiteLabel
            ? [{ whiteLabelId: user?.WhiteLabel?.id }]
            : []
          : formObject.momentsWhiteLabels
      }

      const createdMoment = await createMoment(momentToSave)
      setIsLoading(false)
      setShowLoadingModal(false)
      const toastMessage = momentToSave.id
        ? 'Momento Atualizado com Sucesso.'
        : 'Momento Criado com Sucesso.'
      if (createdMoment.id) {
        history.push('/moments', {
          showToast: true,
          toastMessage
        })
      }
    }
  }

  return (
    <div className="container-fluid">
      <Grid container xs={12} style={{ padding: 15 }}>
        <Grid item xs={12} justify="center">
          <ToastMessages />
          {isLoading ? (
            <LinearProgress marginTop="30px" />
          ) : (
            <Context.Provider
              value={{
                formObject,
                setFormObject,
                iconLogo,
                newLogo,
                setNewLogo,
                crop,
                setCrop,
                logoToUpload,
                setLogoToUpload,
                setOpenToast,
                fullPartnerList,
                setFullPartnerList,
                selectedPartnerList,
                setSelectedPartnerList,
                whiteLabels,
                user
              }}
            >
              <form
                className="clube-form"
                onSubmit={e => {
                  e.preventDefault()
                }}
              >
                {steps.step === 1 && <MomentData />}
                {steps.step === 2 && <SelectUnityToScriptsAndMoments />}
                {steps.step === steps.maxStep && (
                  <div className="col-12">
                    <ImageUpload />
                  </div>
                )}
              </form>
            </Context.Provider>
          )}
        </Grid>
        <Grid item xs={12}>
          <Grid container justify="flex-end">
            <ButtonGZ onClick={handleContinue} disabled={isLoading}>
              {steps.step !== steps.maxStep ? 'Continuar' : 'Salvar'}
            </ButtonGZ>
          </Grid>
        </Grid>
        {!isLoading && (
          <Grid item xs={12} justify="center">
            <Context.Provider value={{ steps, setSteps }}>
              <FormNavigation />
            </Context.Provider>
          </Grid>
        )}
      </Grid>
    </div>
  )
}

MomentForm.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string,
    location: PropTypes.object,
    state: PropTypes.object
  }).isRequired
}

export default MomentForm
